import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { NewString } from '../../functions/ReplaceCharacter.js';

const propTypes = {
  app_name          : PropTypes.string.isRequired,
  app_url           : PropTypes.string.isRequired,
  handleApplication : PropTypes.func.isRequired,
  category          : PropTypes.string.isRequired
}

const ItemApplication = ({ app_name, app_url, handleApplication, category }) => {
  let url = `/applications_softaculous/application/${NewString(app_name, 3)}/${NewString(category, 3)}`;
  return (
    <div className="col-md-3" key = { app_name }>
      <Link to={ url }>
        <div className="card mb-3 shadow-sm">
          <div className="card-body text-center">
            <img  src={ app_url } alt = { app_name } />
            <p className="card-text" style={{ fontSize: '13px' }}>{ app_name }</p>
          </div>
        </div>
      </Link>
    </div>
  )
}

ItemApplication.propTypes = propTypes;

export default ItemApplication;



// WEBPACK FOOTER //
// ./src/components/Menu/ItemApplication.js